<template>
  <div class="userList">
    <div class="page-con-header clearfix">
      <vxe-button type="primary" style="margin-bottom: 10px" @click="addUser"
                  v-if="isHavePermission('user:person:create')">创建个人
      </vxe-button>
      <vxe-button type="primary" style="margin-bottom: 10px" @click="ImportDriver"
                  v-if="isHavePermission('user:person:importDriver')">导入司机用户
      </vxe-button>
      <vxe-button type="primary" style="margin-bottom: 10px" @click="ImportPerUser"
                  v-if="isHavePermission('user:person:importOther')">导入其他用户
      </vxe-button>
      <vxe-button type="primary" style="margin-bottom: 10px" @click="exportPersonalUser"
                  v-if="isHavePermission('user:personal:download')">导出个人用户
      </vxe-button>
      <vxe-button type="primary" style="margin-bottom: 10px" @click="ImportVirAcc"
                  v-if="isHavePermission('user:person:importVirAcc')">批量开通子账户
      </vxe-button>
      <vxe-button type="primary" style="margin-bottom: 10px" @click="batchCheckPhone"
                  v-if="isHavePermission('user:person:batchAliMIdlephoneCheckBySearch')">批量号码校验
      </vxe-button>
      <vxe-button style="margin-bottom: 10px" @click="openFailRecord"
                  v-if="isHavePermission('user:person:wyFailRecord')">号码校验记录
      </vxe-button>
      <vxe-button icon="vxe-icon--refresh" @click="getList" style="margin-left: 20px; margin-bottom: 10px">刷新
      </vxe-button>
      <div class="search-filter" style="margin-right: 0 !important">
        <Poptip placement="bottom-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item title="搜索" span="24" :prefix="{ icon: 'fa fa-address-card-o' }"></vxe-form-item>
              <vxe-form-item title="姓名" field="username" span="12">
                <template v-slot>
                  <Select
                      v-model="searchUserName"
                      clearable
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="(file) => remoteMethod(file,'userNameOptions','baseUserSign','queryUserSignKeyword',1)"
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'userNameOptions')"
                      @on-clear="(file) => remoteMethod(file,'userNameOptions','baseUserSign','queryUserSignKeyword',1)"
                      placeholder="输入客户名称"
                  >
                    <Option
                        v-for="option in userNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="注册手机号" field="regisiterNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.regisiterNum"
                      placeholder="输入手机号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="号码状态" field="regisiterNumState" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.regisiterNumState"
                      :options="regisiterNumStateType"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="身份证号码" field="idcardNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.idcardNum"
                      placeholder="输入身份证号码"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="业务员" field="salesManName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSalesManName"
                      clearable
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="(file) => remoteMethod(file,'salesManNameOptions','baseUserSign','queryUserSignKeyword',3)"
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'salesManNameOptions')"
                      @on-clear="(file) => remoteMethod(file,'salesManNameOptions','baseUserSign','queryUserSignKeyword',3)"
                      placeholder="输入业务员"
                  >
                    <Option
                        v-for="option in salesManNameOptions"
                        :value="option.id"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="联系方式" field="linkPhone" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.linkPhone"
                      placeholder="输入联系方式"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="实名认证状态" field="authStatus" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.authStatus"
                      :options="authStatusType"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="认证来源" field="authSource" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.authSource"
                      :options="authSourceType"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="身份认证状态" field="identityStatus" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.identityStatus"
                      :options="authStatusType"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="身份类型" field="userCategoryStr" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.userCategoryStr"
                      :options="userCategoryType"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="从业资格证" field="hasFile" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.hasFile"
                      :options="fileOptions"
                      placeholder="请选择是否包含附件"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUser" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCreateUser"
                      clearable
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="(file) => remoteMethod(file,'createUserOptions','baseUserSign','queryUserSignKeyword',4)"
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'createUserOptions')"
                      @on-clear="(file) => remoteMethod(file,'createUserOptions','baseUserSign','queryUserSignKeyword',4)"
                      placeholder="输入创建人"
                  >
                    <Option
                        v-for="option in createUserOptions"
                        :value="option.id"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="按创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.createTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button
                      status="primary"
                      icon="ios-search"
                      @click="getSearchListKey"
                      style="border-radius: 5px"
                  >搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px; border-radius: 5px">重置</Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter" style="margin-right: 0 !important">
          <vxe-modal
              class="timeModal"
              v-model="open"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
    </div>
    <vxe-table
        ref="xTable"
        stripe
        class="table-style common-shadow"
        highlight-current-row
        align="center"
        highlight-hover-row
        :loading="loading"
        :data="userList"
        resizable
        @sort-change="sortChangeEvent"
    >
      <vxe-table-column field="id" title="序号" width="100">
        <template slot-scope="{ row }">
          <span>{{ row.id }}</span>
          <Dropdown
              trigger="click"
              style="margin-left: 20px"
              v-if="
                  isHavePermission('user:person:auditAuth') ||
                  isHavePermission('user:person:cancelauth') ||
                  isHavePermission('user:person:auditDriverAuth') ||
                  isHavePermission('user:person:cancelDriverAuth') ||
                  isHavePermission('user:person:linkSalesMan') ||
                  isHavePermission('user:person:delSalesMan') ||
                    isHavePermission('user:person:updateFloatData') ||
                      isHavePermission('user:person:changePhone')
                "
              transfer
          >
            <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
            <DropdownMenu slot="list" style="left: 70px">
              <div style="display: flex; flex-direction: column">
                <Button
                    class="button-gengduo"
                    @click="authUserInfo(row)"
                    v-if="row.authStatus !== 3 && isHavePermission('user:person:auditAuth')">实名认证审核
                </Button>
                <Button
                    class="button-gengduo"
                    v-if="isHavePermission('baseUserSign:reCustomerAdd')"
                    @click="reCustomerAdd(row)"
                >同步企企
                </Button>
                <Button
                    class="button-gengduo"
                    @click="cancelauthUserInfo(row)"
                    v-if="row.authStatus === 3 && isHavePermission('user:person:cancelauth')">取消实名认证
                </Button>
                <Button
                    class="button-gengduo"
                    @click="auditDriverAuth(row)"
                    v-if="row.userCategoryStr && row.userCategoryStr.indexOf('司机') > -1 && row.identityStatus != 3 && isHavePermission('user:person:auditDriverAuth')">
                  司机身份认证
                </Button>
                <Button
                    class="button-gengduo"
                    @click="cancelDriverAuth(row)"
                    v-if="row.userCategoryStr && row.userCategoryStr.indexOf('司机') > -1 && row.identityStatus == 3 && isHavePermission('user:person:cancelDriverAuth')">
                  取消身份认证
                </Button>
                <Button class="button-gengduo" @click="editSalesMan(row)"
                        v-if="row.salesManName == null ||(row.salesManName == '' && isHavePermission('user:person:linkSalesMan'))">
                  关联业务员
                </Button>
                <Button
                    v-if="row.salesManName != null && row.salesManName != '' && isHavePermission('user:person:delSalesMan')"
                    class="button-gengduo"
                    style="color: #ed4014"
                    @click="delSalesMan(row)"
                >移除业务员
                </Button>
                <Button class="button-gengduo" @click="showEditFloatData(row)"
                        v-if="isHavePermission('user:person:updateFloatData')">修改浮动数据
                </Button>
                <Button class="button-gengduo" @click="changePhone(row)"
                        v-if="isHavePermission('user:person:changePhone')">修改手机号
                </Button>
                <Button class="button-gengduo" @click="batchAliMIdlephoneCheckByNum(row)"
                        v-if="isHavePermission('user:person:batchAliMIdlephoneCheckByNum')">重新校验号码
                </Button>
                <Button class="button-gengduo" style="color: red" @click="commitDelete(row)"
                        v-if="isHavePermission('user:person:delete')">
                  删除用户
                </Button>
              </div>
            </DropdownMenu>
          </Dropdown>
        </template>
      </vxe-table-column>
      <vxe-table-column field="userName" min-width="140" title="姓名" show-overflow>
        <template slot-scope="{ row }">
          <span @click="userInfo(row)" style="cursor: pointer; color: #2d8cf0">{{ row.userName }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="regisiterNum" min-width="180" title="注册手机号" show-overflow>
        <template slot-scope="{ row }">
          <span :style="row.isSystemPhone === 1 ? 'color:red;':''">{{ row.regisiterNum }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="userCategoryStr" min-width="180" title="身份类型" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.userCategoryStr }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="idcardNum" min-width="180" title="身份证号" show-overflow></vxe-table-column>
      <vxe-table-column field="phoneStatus" min-width="180" title="号码状态" show-overflow>
        <template slot-scope="{ row }">
          <span :style="row.isSystemPhone === 1 ? 'color:red;':''">{{ phoneStatus(row) }}</span>
          <Dropdown v-if="row.isSystemPhone !== 1 && isHavePermission('user:person:changePhoneStatus')"
                    trigger="click" style="margin-left: 10px;;cursor:pointer" transfer>
              <span style="position:relative; margin-left:20px; ">
                <Icon type="ios-arrow-down" style="margin-top:-3px;"/>
              </span>
            <DropdownMenu slot="list" style="left:70px;">
              <div style="display: flex;flex-direction: column;">
                <section v-for="item in phoneStatusOptions" v-bind:key="item.value">
                  <Button class="button-gengduo" @click="changeStatus(row.id,item.value)">{{ item.label }}
                  </Button>
                </section>
              </div>
            </DropdownMenu>
          </Dropdown>
        </template>
      </vxe-table-column>
      <vxe-table-column field="authStatus" min-width="180" title="实名认证" show-overflow>
        <template slot-scope="{ row }">
          <span style="display: inline-block; margin-left: 10px; cursor: pointer; color: #f59a23"
                @click="auditAuth(row)">{{ authStatus(row) }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="authTime" min-width="180" title="认证时间" show-overflow remote-sort>
        <template slot-scope="{ row }">
          <span style="color: #a7adad">{{ row.authTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="identityStatus" min-width="180" title="身份认证" show-overflow>
        <template slot-scope="{ row }">
          <span v-if="row.userCategoryStr && row.userCategoryStr.indexOf('司机') > -1">{{
              row.identityStatus | authStatusRule
            }}</span>
          <span v-else> -- </span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="updateUser" min-width="180" title="操作人" show-overflow></vxe-table-column>
      <vxe-table-column field="updateTime" min-width="180" title="操作时间" show-overflow>
        <template slot-scope="{ row }">
          <span style="color: #a7adad">{{ row.updateTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="createUser" min-width="180" title="创建人" show-overflow></vxe-table-column>
      <vxe-table-column field="createTime" min-width="180" title="创建时间" show-overflow>
        <template slot-scope="{ row }">
          <span style="color: #a7adad">{{ row.createTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
        background
        size="small"
        :current-page.sync="current"
        :page-size.sync="pageSize"
        :total="userTotal"
        @page-change="change"
    ></vxe-pager>
    <vxe-modal v-model="editSalesManModal" title="关联业务员" width="800" height="560" resize remember>
      <choose-sales-man ref="chooseSalesMan" @chooseSalesMan="chooseSalesMan"></choose-sales-man>
    </vxe-modal>
    <vxe-modal v-model="userInfoModal" width="1450" height="800" position="center" title="查看用户信息" destroy-on-close>
      <user-center :userId="editUserId" :userType="userType" :isUserEdit="false" :userName="userName"
                   :salesManName="salesManName" ref="userCenter" @submitC="submitC"></user-center>
    </vxe-modal>
    <vxe-modal v-model="templateVisible" :title="templateTitle" width="1000" height="620" @close="closeTemplate"
               position="center">
      <import @goImport="goImport" @close="closeTemplate" ref="modalTemplate"></import>
    </vxe-modal>
    <vxe-modal v-model="importPerVisible" title="导入个人用户" width="1200" height="620" @close="closePerImport" resize
               position="center">
      <import-per @afterSave="closePerImportModal" ref="modalPerImport"></import-per>
    </vxe-modal>
    <vxe-modal v-model="importDriverVisible" title="导入司机用户" width="1200" height="620" @close="closeDriverImport" resize
               position="center">
      <import-driver @afterSave="closeDriverImportModal" ref="modalDriverImport"></import-driver>
    </vxe-modal>
    <vxe-modal v-model="importVirAccVisible" title="批量开通子账户" width="1200" height="620" @close="closeVirAccImport" resize
               position="center">
      <import-vir-acc @afterSave="closeVirAccImportModal" ref="modalVirAccImport"></import-vir-acc>
    </vxe-modal>
    <vxe-modal v-model="recModal" title="号码校验记录" width="1000" height="620" resize position="center">
      <import-record ref="recModal"></import-record>
    </vxe-modal>
    <vxe-modal v-model="perAuthVisible" title="个人认证" width="1000" height="700" resize
               position="center">
      <per-authentication ref="perAuth" @close="perAuthVisible = false"></per-authentication>
    </vxe-modal>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" remember>
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
    <vxe-modal v-model="linkModal" width="500" height="200" resize remember title="添加关联企业" position="center">
      <link-comp ref="linkComp" @afterSave="afterLink" @close="linkModal = false"></link-comp>
    </vxe-modal>
    <vxe-modal v-model="isShowChangePhone" title="变更手机号" width="500" height="300" position="center" destroy-on-close>
      <change-phone ref="changePhone" :isPer="true" @afterChange="getList" @close="isShowChangePhone = false"></change-phone>
    </vxe-modal>
    <edit-user-monitor-data ref="editUserMonitorData"></edit-user-monitor-data>
    <vxe-modal v-model="batchTip" position="center" title="消息提示">
      <template slot="header">
        消息提示
      </template>
      <div style="display: flex; flex-direction: column">
        <div style="display: flex; align-items: center">
          <i class="vxe-icon--warning" style="color: #e6a23c; font-size: 22px"></i>
          <span style="margin-left: 10px">确认要批量核验未校验的手机号?</span>
        </div>
        <span style="margin-left: 30px;font-size: 12px;color: red;">(稍后前往号码校验记录中查看)</span>
        <div style="margin-left: auto; margin-top: 20px">
          <Button style="border-radius: 5px" @click="batchTip = false">取消</Button>
          <Button type="primary" style="margin-left: 10px; border-radius: 5px" @click="batchAliMIdlephoneCheckBySearch">
            确认
          </Button>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>
<script>

import getAuthOrization from "@/mixin/getAuthOrization";
import $C from "@/consts";
import {SEARCH_TIME} from "@/filters/time";
import $api from "@/apiProvider";
import {hideLoading, isEmpty, postBlob, saveBlob, showLoading} from "@/utils/util";
import moment from "moment";
import UserCenter from "@/views/account/UserCenter";
import Import from "@/components/common/Import"; // 导入
import ImportPer from "@/views/user/ImportPer";
import ImportDriver from "@/views/user/ImportDriver";
import importVirAcc from "@/views/user/importVirAcc";
import ImportRecord from "@/views/user/ImportRecord";
import ChooseSalesMan from "@/components/modal/ChooseSalesMan";
import perAuthentication from "@/views/account/perAuthentication";
import Message from "@/components/common/Message";
import LinkComp from "@/components/modal/LinkComp";
import ChangePhone from "@/views/newUser/ChangePhone";
import {apiPost} from "@/utils/api";
import Auth from "@/utils/auth";
import EditUserMonitorData from "@/components/common/EditUserMonitorData";

export default {
  components: {
    ImportRecord,
    ChooseSalesMan,
    UserCenter,
    Import,
    ImportPer,
    ImportDriver,
    importVirAcc,
    perAuthentication,
    Message,
    LinkComp,
    ChangePhone,
    EditUserMonitorData
  },
  mixins: [getAuthOrization],
  data() {
    return {
      batchTip: false,
      isShowChangePhone: false,
      linkModal: false,
      messageVisible: false,
      perAuthVisible: false,
      importDriverVisible: false,
      templateTitle: "",
      templateVisible: false,
      importPerVisible: false,
      importCompVisible: false,
      importVirAccVisible: false,
      userInfoModal: false,
      editSalesManModal: false,
      recModal: false,
      listQuery: {
        page: 1,
        rows: 10,
        userType: 1,
        userName: null,
        orderBy: 2,
        isDesc: 1,
      },
      userTotal: 50,
      searchUserName: null,
      userNameOptions: [],
      searchSalesManName: null,
      salesManNameOptions: [],
      searchCreateUser: null,
      createUserOptions: [],
      searchLoading: false,
      searchVisible: false,
      open: false,
      userId: null,
      userType: null,
      editUserId: 0,
      userName: null,
      salesManName: null,
      searchFormData: {
        username: null,
        salesManName: null,
        compName: null,
        linkMan: null,
        linkPhone: null,
        authStatus: null,
        identityStatus: null,
        createUser: null,
        realName: null,
        time: null,
        userCategory: null,
        hasFile: null,
        regisiterNum: null,
        hasBusinessFile: null,
        authSource: null
      },
      hasBusinessFileType: [
        {
          label: "已上传",
          value: 1,
        },
        {
          label: "未上传",
          value: 0,
        },
      ],
      authStatusType: $C.AUDIT_STATUS.options,
      authSourceType: [{
        label: '平台',
        value: 1
      },
        {
          label: '法大大',
          value: 2
        },
        {
          label: '网易',
          value: 3
        }
      ],
      phoneStatusOptions: [
        {
          label: '正常',
          value: 1
        },
        {
          label: '停机',
          value: 2
        },
        {
          label: '关机',
          value: 6
        },
        {
          label: '空号',
          value: 0
        },
        {
          label: '疑似关机',
          value: 7
        },
        {
          label: '忙',
          value: 8
        },
        {
          label: '未知',
          value: 9
        },
        {
          label: '未校验',
          value: 10
        },
        // {
        //   label: '无记录',
        //   value: 3
        // },
        // {
        //   label: '沉默号',
        //   value: 4
        // },
        // {
        //   label: '风险号',
        //   value: 5
        // },
        // {
        //   label: '关机',
        //   value: 6
        // },
        // {
        //   label: '疑似关机',
        //   value: 7
        // },
        // {
        //   label: '忙',
        //   value: 8
        // },
        // {
        //   label: '未知',
        //   value: 9
        // }
      ],
      regisiterNumStateType: [
        {
          label: '正常',
          value: 1
        },
        {
          label: '停机',
          value: 2
        },
        {
          label: '关机',
          value: 6
        },
        {
          label: '空号',
          value: 0
        },
        {
          label: '疑似关机',
          value: 7
        },
        {
          label: '忙',
          value: 8
        },
        {
          label: '未知',
          value: 9
        },
        {
          label: '系统号',
          value: -1
        },
        {
          label: '未校验',
          value: 10
        },
        // {
        //   label: '无记录',
        //   value: 3
        // },
        // {
        //   label: '沉默号',
        //   value: 4
        // },
        // {
        //   label: '风险号',
        //   value: 5
        // }
      ],
      timeOptions: SEARCH_TIME.options,
      fileOptions: $C.HAS_FILE_TYPE.options,
      current: 1,
      pageSize: 10,
      loading: false,
      userCategoryMap: new Map(),
      userCategoryData: {
        options: [],
      },
      userCategoryType: [{
        label: '货主',
        value: '货主'
      },
        {
          label: '船东',
          value: '船东'
        },
        {
          label: '司机',
          value: '司机'
        },
        {
          label: '代理',
          value: '代理'
        },
        {
          label: '船员',
          value: '船员'
        },
        {
          label: '供应商',
          value: '供应商'
        },
        {
          label: '其他',
          value: '其他'
        }
      ],
      userList: [],
      templateType: null,
    }
  },
  filters: {
    authStatusRule(val) {
      if (val != null) {
        if (val === 0) {
          return "未认证";
        }
        if (val === 1) {
          return "待审核";
        }
        if (val === 2) {
          return "未通过";
        }
        if (val === 3) {
          return "已认证";
        }
        if (val === 4) {
          return "已失效";
        }
      } else {
        return "未认证";
      }
    },
    userCategoryRule(val) {
      if (val != null) {
        if (val === 1) {
          return "托运人";
        }
        if (val === 2) {
          return "承运人";
        }
        if (val === 3) {
          return "代理";
        }
        if (val === 4) {
          return "货车承运商";
        }
        if (val === 5) {
          return "司机";
        }
        if (val === 6) {
          return "船东";
        }
        if (val === 7) {
          return "其他";
        }
      }
    },
  },
  watch: {
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
  },
  created() {
    this.$bus.$on("afterCreatePerson", data => {
      if (data) {
        this.getList(this.paramsObj);
      }
    });
  },
  mounted() {
    this.getList();
    this.getDicUserCategoryList();
  },
  methods: {
    sortChangeEvent(sort) {
      if (sort.order == null) {
        this.listQuery.orderBy = 2
        this.listQuery.isDesc = null
      } else {
        this.listQuery.isDesc = sort.order === 'desc' ? 1 : 0
        if (sort.field === 'authTime') {
          this.listQuery.orderBy = 13;
        }
      }
      this.getList();
    },
    commitDelete(row) {
      this.$XModal.confirm("您确定要删除个人用户：" + row.userName + "吗？").then(type => {
        if (type === "confirm") {
          this.deleteUser(row);
        }
      });
    },
    async deleteUser(row) {
      showLoading();
      let data = {
        id: row.id,
      };
      let res = await $api.baseUserSign.request("deleteUser", data);
      hideLoading();
      if (res.status === 1) {
        this.getList();
        this.$XModal.message({message: `操作成功！`});
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    showEditFloatData(row) {
      this.$refs.editUserMonitorData.init(row.id);
    },
    async changeStatus(id, state) {
      let res = await apiPost("api/auth/", "baseUserSign/editRegisterNumState", {
        userIdGyl: id,
        regisiterNumState: state
      });
      if (res.status === 1) {
        this.$Message.success('操作成功');
        this.getList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    changePhone(row) {
      this.isShowChangePhone = true;
      this.$nextTick(() => {
        this.$refs.changePhone.setUpdate(row);
      })
    },
    phoneStatus(row) {
      if (row.isSystemPhone === 1) {
        return '系统号'
      } else {
        if (row.regisiterNumState === 0) {
          return '空号'
        }
        if (row.regisiterNumState === 1) {
          return '正常'
        }
        if (row.regisiterNumState === 2) {
          return '停机'
        }
        if (row.regisiterNumState === 3) {
          return '无记录'
        }
        if (row.regisiterNumState === 4) {
          return '沉默号'
        }
        if (row.regisiterNumState === 5) {
          return '风险号'
        }
        if (row.regisiterNumState === 6) {
          return '关机'
        }
        if (row.regisiterNumState === 7) {
          return '疑似关机'
        }
        if (row.regisiterNumState === 8) {
          return '忙'
        }
        if (row.regisiterNumState === 9) {
          return '未知'
        }
        if (row.regisiterNumState === 10) {
          return '未校验'
        }
      }
    },
    authStatus(row) {
      let val = row.authStatus;
      if (val != null) {
        if (val === 0) {
          return "未认证";
        }
        if (val === 1) {
          return "待审核";
        }
        if (val === 2) {
          return "未通过";
        }
        if (val === 3) {
          if (row.authSource === 1) {
            return "已认证(平台)";
          } else if (row.authSource === 2) {
            return "已认证(法大大)";
          } else if (row.authSource === 3) {
            return "已认证(网易)";
          } else {
            return "已认证";
          }
        }
        if (val === 4) {
          return "已失效";
        }
      } else {
        return "未认证";
      }
    },
    submitC(val) {
      if (val) {
        this.getList();
      }
    },
    goImport() {
      this.templateVisible = false;
      if (this.templateType === 0) {
        this.importPerVisible = true;
      } else if (this.templateType === 1) {
        this.importCompVisible = true;
      } else if (this.templateType === 2) {
        this.importDriverVisible = true;
        this.$nextTick(() => {
          this.$refs.modalDriverImport.close();
        });
      } else {
        this.importVirAccVisible = true;
      }
    },
    afterLink() {
      this.linkModal = false;
      this.getList();
    },
    openFailRecord() {
      this.recModal = true;
      this.$nextTick(() => {
        this.$refs.recModal.init();
      })
    },
    userInfo(row) {
      this.userType = row.userType;
      this.salesManName = row.salesManName;
      this.editUserId = row.id;
      this.userInfoModal = true
      this.userName = row.realName;
    },
    closeMessage() {
      this.messageVisible = false;
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    closeVirAccImport() {
      this.$refs.modalVirAccImport.close();
    },
    closeVirAccImportModal() {
      this.getList();
      this.importVirAccVisible = false;
    },
    closePerImport() {
      this.$refs.modalPerImport.close();
    },
    closeDriverImport() {
      this.$refs.modalDriverImport.close();
    },
    closePerImportModal(message) {
      if (message) {
        this.$refs.messageModal.setMessage(message);
        this.messageVisible = true;
      }
      this.getList();
      this.importPerVisible = false;
    },
    closeDriverImportModal(message) {
      if (message) {
        this.$refs.messageModal.setMessage(message);
        this.messageVisible = true;
      }
      this.getList();
      this.importDriverVisible = false;
    },
    async batchAliMIdlephoneCheckByNum(row) {
      showLoading();
      let res = await $api.baseUserSign.post("batchAliMIdlephoneCheckByNum", {
        regisiterNum: row.regisiterNum
      });
      hideLoading();
      if (res.status === 1) {
        this.$XModal.message({message: `操作成功！`});
        this.getList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async chooseSalesMan(val) {
      var data = {
        id: this.userId,
        salesManId: val.id,
      };
      let res = await $api.baseUserSign.post("updateSignUserSaleMan", data);
      if (res.status == 1) {
        this.getList();
        this.$XModal.message({message: `关联成功！`});
        this.editSalesManModal = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    batchCheckPhone() {
      if (isEmpty(this.userList)) {
        this.$XModal.message("暂无数据");
        return;
      }
      this.batchTip = true;
    },
    async batchAliMIdlephoneCheckBySearch() {
      this.$XModal.message({message: `操作成功！`});
      this.batchTip = false;
      let res = await $api.baseUserSign.post("batchAliMIdlephoneCheckBySearch", this.listQuery);
      if (res.status === 0) {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async exportPersonalUser() {
      if (isEmpty(this.userList)) {
        this.$XModal.message("暂无数据");
        return;
      }
      showLoading();
      let res = postBlob("/api/admin/baseUserSign/exportPersonalUser", this.listQuery);
      hideLoading();
      await saveBlob("导出个人用户列表.xls", res.data);
    },
    ImportVirAcc() {
      this.templateType = 3;
      this.templateVisible = true;
      this.templateTitle = "批量开通子账户";
      this.$refs.modalTemplate.setExport("批量开通个人子账户导入模板.xls");
    },
    ImportDriver() {
      this.templateType = 2;
      this.templateVisible = true;
      this.templateTitle = "司机用户导入";
      this.$refs.modalTemplate.setExport("0705个人司机导入模板.xls");
    },
    ImportPerUser() {
      this.templateType = 0;
      this.templateVisible = true;
      this.templateTitle = "个人用户导入";
      this.$refs.modalTemplate.setExport("0705个人客户导入模板.xls");
    },
    getList() {
      this.loading = true;
      let data = this.listQuery;

      $api.gcdUser.queryGcdUserListModel
          .POST({
            data,
          })
          .then((response) => {
            if (parseInt(response.status) === 1) {
              let res = response.data;
              res.rows.map(i => {
                i.showUserCategory = this.userCategoryMap.get(i.userCategory);
              })
              this.userList = res.rows;
              this.userTotal = res.total;
              this.loading = false;
            } else {
              this.$XModal.alert({
                message: response.message ? response.message : "接口异常",
                status: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    auditAuth(row) {
      //认证状态0.未认证 1.已提交/待审核 2.未通过 3.通过 4.已过期',
      this.perAuthVisible = true;
      this.$nextTick(() => {
        this.$refs.perAuth.init(row.id);
      })
    },
    reset() {
      this.searchUserName = null;
      this.searchSalesManName = null;
      this.searchCreateUser = null;
      this.searchFormData = {
        username: null,
        salesManName: null,
        compName: null,
        linkMan: null,
        linkPhone: null,
        authStatus: null,
        identityStatus: null,
        createUser: null,
        realName: null,
        time: null,
        userCategory: null,
        hasFile: null,
        regisiterNum: null,
        hasBusinessFile: null,
        authSource: null
      };
      this.listQuery = {
        page: 1,
        rows: 10,
        userType: 1,
        userName: null,
        orderBy: 2,
        isDesc: 1,
      };
      this.$refs.xTable.clearSort();
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeVal);
    },
    handleClear() {
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.searchVisible = true;
      }, 100);
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getSearchList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getSearchList(query, options, url, path, columnType) {
      let params = {
        columnType: columnType,
        moduleType: 1
      };

      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i);
          }
        });
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    change(val) {
      this.listQuery.page = val.currentPage;
      this.listQuery.rows = val.pageSize;
      this.getList();
    },
    getDicUserCategoryList() {
      let self = this;
      $api.other.getDicUserCategoryModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              let obj = {
                label: item.dictText,
                value: item.dictCode,
              };
              self.userCategoryData.options.push(obj);
              self.userCategoryMap.set(item.dictCode, item.dictText);
            });
            // self.userCategoryType = JSON.parse(JSON.stringify(self.userCategoryData.options));
          });
    },
    authUserInfo(row) {
      this.$XModal.confirm("该操作将把该用户变为认证状态").then((type) => {
        if (type === "confirm") {
          this.commitAuthUser(row);
        }
      });
    },
    async commitAuthUser(row) {
      var self = this;
      var data = {
        id: row.id,
      };
      new Promise((resolve, reject) => {
        $api.gcdUser.queryGcdUserModel
            .POST({
              data,
            })
            .then((response) => {
              if (response.data.userType == 1) {
                if (
                    response.data.idcardBackUrl == null ||
                    response.data.idcardBackUrl == "" ||
                    response.data.idcardFrontUrl == null ||
                    response.data.idcardFrontUrl == "" ||
                    response.data.idcardNum == null ||
                    response.data.realName == null
                ) {
                  this.$XModal.alert({
                    message: "资料不全，请先上传认证资料",
                    status: "error",
                  });
                  return;
                }
              } else if (response.data.userType == 2) {
                if (response.data.userCategory == 4) {
                  if (
                      response.data.transportLicenseUrl == null ||
                      response.data.transportLicenseUrl == ""
                  ) {
                    this.$XModal.alert({
                      message: "资料不全，请先上传认证资料",
                      status: "error",
                    });
                    return;
                  }
                }
                if (
                    response.data.businessUrl == null ||
                    response.data.businessUrl == "" ||
                    response.data.compName == null ||
                    response.data.taxNum == null
                ) {
                  this.$XModal.alert({
                    message: "资料不全，请先上传认证资料",
                    status: "error",
                  });
                  return;
                }
              }
              var param = {
                auditUserId: parseInt(Auth.getAuth().id),
                auditStatus: 3,
                userId: row.id,
              };
              if (response.data.userType == 1) {
                this.commitauthTwo(param);
              }
              self.$forceUpdate();
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
      });
    },
    async commitauthTwo(formData) {
      var self = this;
      let res = await $api.authUser.request("auditAuthPerson", formData);
      if (res.status == 1) {
        self.getList();
        this.$Message["success"]({
          background: true,
          content: "认证成功",
        });
        self.editSalesManModal = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    auditDriverAuth(row) {
      this.$XModal.confirm("该操作将认证该用户的司机身份").then((type) => {
        if (type === "confirm") {
          this.commitDriver(row);
        }
      });
    },
    commitDriver(row) {
      let self = this;
      let data = {
        id: row.id,
      };
      new Promise((resolve, reject) => {
        $api.gcdUser.queryGcdUserModel
            .POST({
              data,
            })
            .then((response) => {
              if (response.data.userType == 1) {
                if (
                    response.data.drivingCardFrontUrl == null ||
                    response.data.drivingCardFrontUrl == "" ||
                    response.data.drivingCardSubpageUrl == null ||
                    response.data.drivingCardSubpageUrl == ""
                ) {
                  this.$XModal.alert({
                    message: "资料不全，请先上传认证资料",
                    status: "error",
                  });
                  return;
                }
              }
              this.commitAuthDriver(row);
              self.$forceUpdate();
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
      });
    },
    reCustomerAdd(row) {
      this.$XModal.confirm("该操作将重新同步企企").then((type) => {
        if (type === "confirm") {
          this.commitCustomerAdd(row);
        }
      });
    },
    async commitCustomerAdd(row) {
      var data = {
        id: row.id,
      };
      this.loading = true;
      let res = await $api.baseUserSign.request("reCustomerAdd", data);
      this.loading = false;
      if (res.status == 1) {
        this.$XModal.message({message: `操作成功！`});
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    async commitAuthDriver(row) {
      var self = this;
      var xxx = {
        userId: row.id,
        identityStatus: 3,
        type: 1,
      };
      let res = await $api.authUser.request("auditDriverAuth", xxx);
      if (res.status == 1) {
        self.getList();
        this.$Message["success"]({
          background: true,
          content: "操作成功",
        });
        self.editSalesManModal = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    cancelauthUserInfo(row) {
      this.$XModal.confirm("该操作将取消用户认证").then((type) => {
        if (type === "confirm") {
          this.commitCancelAuthUser(row);
        }
      });
    },
    async commitCancelAuthUser(row) {
      var self = this;
      var param = {
        userId: row.id,
        remark: "您的认证已失效",
      };
      let res = await $api.authUser.request("cancelAuth", param);
      if (res.status == 1) {
        self.getList();
        this.$Message["success"]({
          background: true,
          content: "操作成功",
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    cancelDriverAuth(row) {
      this.$XModal.confirm("该操作将取消司机身份认证").then((type) => {
        if (type === "confirm") {
          this.commitCancelAuthDriver(row);
        }
      });
    },
    async commitCancelAuthDriver(row) {
      let self = this;
      let xxx = {
        id: row.id,
        remark: "您的认证已失效",
      };

      let res = await $api.authUser.request("cancelDriverAuth", xxx);
      if (res.status == 1) {
        self.getList();
        this.$Message["success"]({
          background: true,
          content: "操作成功",
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    editSalesMan(row) {
      this.editSalesManModal = true;
      this.$refs.chooseSalesMan.init();
      this.userId = row.id;
    },
    delSalesMan(row) {
      this.$XModal.confirm("您确定要移除业务员吗？").then((type) => {
        if (type === "confirm") {
          this.commitDelSalesMan(row);
        }
      });
    },
    async commitDelSalesMan(row) {
      var data = {
        id: row.id,
        salesManId: 0,
      };
      let res = await $api.baseUserSign.post("updateSignUserSaleMan", data);
      if (parseInt(res.status) === 1) {
        this.getList();
        this.$Message["success"]({
          background: true,
          content: "移除成功",
        });
        this.editSalesManModal = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    getSearchListKey() {
      let paramsObj = Object.assign({}, this.listQuery);
      let obj = this.searchFormData;
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== null && key !== "createTime") {
          paramsObj[key] = obj[key];
        }
        if (obj["createTime"] && obj["createTime"].length > 0) {
          paramsObj.beginDate = moment(obj.createTime[0]).valueOf(); // 开始时间
          paramsObj.endDate = moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
        }
      });

      if (this.searchUserName) {
        paramsObj.username = this.searchUserName;
      }
      if (this.searchSalesManName) {
        paramsObj.salesManId = this.searchSalesManName;
      }
      if (this.searchCreateUser) {
        paramsObj.createUserId = this.searchCreateUser;
      }
      paramsObj.page = 1;
      this.current = 1;
      paramsObj.userType = 1;

      paramsObj.rows = this.pageSize;
      this.listQuery = paramsObj;
      this.getList();
      this.searchVisible = false;
      // this.queryOrderListByObj(paramsObj);
    },
    addUser() {
      let obj = {
        name: `新建个人客户`,
        path: `/newUser/createPerson`
      };
      // this.$store.dispatch("tagsView/addVisitedView", obj);
      // this.$router.push(obj.path);
      window.open(obj.path)
    },
  }
}
</script>